import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { parseDateMMDDYYYYSlashes } from '@mummssoftware/utils/dates';
import { formatDate } from '@mummssoftware/utils/medications/utils';
import { styles } from '../../../utils/styles';
export const MedStartStopPDF = ({
  med
}) => {
  const startDateString = med.startdate_shifted ? formatDate(parseDateMMDDYYYYSlashes(med.startdate_shifted)) : '';
  const stopDateString = med.stopdate_shifted ? ` - ${formatDate(parseDateMMDDYYYYSlashes(med.stopdate_shifted))}` : '';
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width16
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.medsTableMainDetailsText
  }, `${startDateString}${stopDateString}`));
};